import React from 'react'
import { shape, string, number, bool } from 'prop-types'
import { css } from '@emotion/react'

import PaymentFreeIcon from '@/assets/icons/payment-free.inline.svg'
import PaymentLicense from '@/assets/icons/payment-LClicense.inline.svg'
import PaymentSingleIcon from '@/assets/icons/payment-single.inline.svg'
import { formatPrice } from '@/utils/products'

const paymentLabelCss = (theme) => css`
  font-size: 15px;
  line-height: 20px;
  display: flex;
  align-items: center;
  font-weight: 400;
  overflow: hidden;

  > span {
    opacity: 0.5;
    overflow: hidden;
    text-overflow: ellipsis;

    > sup {
      font-size: 8px;
      top: -2px;
      font-weight: 700;
      margin-right: 2px;
    }
  }

  > svg {
    fill: ${theme.colors.cornflowerBlue};
    width: 14px;
    height: 14px;
    display: none;
  }
`

const PaymentLabel = ({ payment, defaultCurrencySign }) => {
  return (
    <span css={paymentLabelCss}>
      {!payment && (
        <>
          <PaymentFreeIcon />
          <span>Free to install</span>
        </>
      )}

      {payment?.frequency === 'once' && (
        <>
          <PaymentSingleIcon />{' '}
          <span>
            {defaultCurrencySign ? '$' : <sup>$</sup>}
            {formatPrice(payment.price)}
          </span>
        </>
      )}

      {payment?.frequency === 'monthly' && (
        <>
          <PaymentLicense />{' '}
          <span>
            {defaultCurrencySign ? '$' : <sup>$</sup>}
            {formatPrice(payment.price)} / mo
          </span>
        </>
      )}
    </span>
  )
}

PaymentLabel.propTypes = {
  payment: shape({
    frequency: string,
    price: number,
  }),
  defaultCurrencySign: bool,
}

export default PaymentLabel
